<select class="custom-select custom-select-sm"  name="{{name}}" [(ngModel)]="value" (ngModelChange)="onChange()"  >
    <option *ngFor="let t of tables" value="{{t.table}}">{{t.label}}</option> 
    <option value="" *ngIf="show_all"><i class=""></i>TUTTE</option>
</select>
